export default function SlimeVolleyIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M4 52h56" stroke="#3B434F" strokeWidth="3" strokeLinecap="round" />
      <rect x="30" y="32" width="4" height="20" fill="#3B434F" />
      <path d="M5 52a12 12 0 0 1 24 0Z" fill="#2F8BFF" />
      <path d="M35 52a12 12 0 0 1 24 0Z" fill="#FF8A1F" />
      <circle cx="22" cy="20" r="6" fill="#E7ECF3" />
      <path d="M14 34 Q17 25 21 22" stroke="#E7ECF3" strokeOpacity="0.4" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}
